import { connect } from 'react-redux'
import ServiceViewProducts from '../../components/services/view/ServiceViewProducts'
import { IStoreState } from '../../types/index'
import { fetchProductsByOrganizationId } from '../../state/actions/provider-products'
import { getServicesProducts } from '../../state/reducers/provider-products/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    organizationId: state.organizations.currentOrgId || '',
    serviceProducts: getServicesProducts(state, ownProps.serviceId)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchProductsByOrganizationId: (organizationId: string) => {
      const dto = {
        organizationId,
        skip: 0,
        take: 9999, // get all existing products
        active: true
      }
      dispatch(fetchProductsByOrganizationId(dto))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewProducts)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewProducts.ts